import { useRequest } from 'ahooks';
import { useEffect } from 'react';
import { useReadyInfo } from '@/providers/ReadyProvider';
import { fetchBlackBookMemberList } from '@/services/account';

/**
 * 获取停车优惠原因
 * - reason_list 优惠原因
 */
const useBlackBookMemberList = () => {
  const { blackBookMemberList, setBlackBookMemberList } = useReadyInfo();

  const {
    run: getBlackBookMemberList,
    data,
    loading,
  } = useRequest(fetchBlackBookMemberList, { manual: true });

  useEffect(() => {
    if (!blackBookMemberList || !blackBookMemberList?.reason_list) {
      getBlackBookMemberList().then((res) =>
        setBlackBookMemberList({
          reason_list:
            res?.reason_list?.map((v) => {
              return { label: v.name, value: String(v.id), placeholder: v.placeholder_name };
            }) ?? [],
        })
      );
    }
  }, [blackBookMemberList]);

  return {
    data: blackBookMemberList || {
      reason_list:
        data?.reason_list?.map((v) => {
          return { label: v.name, value: String(v.id), placeholder: v.placeholder_name };
        }) ?? [],
    },
    loading,
  };
};

export default useBlackBookMemberList;
